import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, image, type = 'website' }) => {
  const location = useLocation();
  const siteUrl = window.location.origin;
  const currentUrl = siteUrl + location.pathname;

  const pageMeta = {
    '/menu': {
      title: "Notre carte — burgers, tacos, desserts | Le Family's Bourg-en-Bresse",
      description: "Découvrez la carte du Family's : burgers artisanaux, tacos, desserts et boissons, 100% halal. Prix et menus à jour. Commandez en ligne ou sur place à Bourg-en-Bresse."
    },
    '/contact': {
      title: "Nous trouver — adresse, horaires, téléphone | Le Family's Bourg-en-Bresse",
      description: "Le Family's, restaurant halal : 59 rue du 14 Juillet 1789, 01000 Bourg-en-Bresse. Ouvert du mardi au dimanche, 11h30-14h et 18h-minuit. Tél. 04 74 52 60 82."
    },
    '/application': {
      title: "L'appli Le Family's — commande en 30 s, fidélité 5% | Bourg-en-Bresse",
      description: "Téléchargez l'application Le Family's : commandez vos burgers et tacos halal en 30 secondes, cumulez 5 % crédités sur votre carte de fidélité et jouez à la roue de la fortune."
    }
  };
  const routeMeta = pageMeta[location.pathname] || {};
  const defaultTitle = routeMeta.title || "Le Family's — Restaurant halal Burgers & Tacos à Bourg-en-Bresse";
  const defaultDescription = routeMeta.description || "Restaurant fast food 100% halal à Bourg-en-Bresse. Burgers artisanaux, tacos savoureux, desserts gourmands, sans alcool. Commandez en ligne ou sur Uber Eats. Note Google 4.3★";
  const defaultImage = "/images/logo-familys.png";

  const metaTitle = title || defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;

  useEffect(() => {
    // Mettre à jour le titre
    document.title = metaTitle;

    // Fonction pour mettre à jour ou créer une meta tag
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Meta tags standards
    updateMetaTag('description', metaDescription);
    updateMetaTag('keywords', 'restaurant halal Bourg-en-Bresse, halal Bourg, burgers halal, tacos halal, fast food halal, livraison, Uber Eats, Family\'s');

    // Open Graph tags
    updateMetaTag('og:title', metaTitle, true);
    updateMetaTag('og:description', metaDescription, true);
    updateMetaTag('og:image', metaImage, true);
    updateMetaTag('og:url', currentUrl, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:site_name', "LE FAMILY'S", true);
    updateMetaTag('og:locale', 'fr_FR', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', metaTitle);
    updateMetaTag('twitter:description', metaDescription);
    updateMetaTag('twitter:image', metaImage);

    // JSON-LD Schema pour Restaurant
    const schemaScript = document.getElementById('schema-restaurant');
    if (schemaScript) {
      schemaScript.remove();
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "Restaurant",
      "name": "LE FAMILY'S",
      "image": metaImage,
      "description": metaDescription,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "59 Rue du 14 Juillet 1789",
        "addressLocality": "Bourg-en-Bresse",
        "postalCode": "01000",
        "addressCountry": "FR"
      },
      "telephone": "04 74 52 60 82",
      "email": "lefamilys01@gmail.com",
      "url": siteUrl,
      "servesCuisine": ["Halal", "Fast Food", "Burgers", "Tacos"],
      "keywords": "restaurant halal Bourg-en-Bresse, burgers halal, tacos halal",
      "priceRange": "€",
      "acceptsReservations": false,
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.3",
        "bestRating": "5",
        "ratingCount": "100"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "11:30",
          "closes": "00:00"
        }
      ],
      "menu": currentUrl + "/menu",
      "hasMenu": currentUrl + "/menu"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-restaurant';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

  }, [metaTitle, metaDescription, metaImage, currentUrl, type]);

  return null;
};

export default SEO;
